var styles = {
  "LogoWrapper": "pb-Logo__LogoWrapper",
  "Logo": "pb-Logo__Logo",
  "stretcher": "pb-Logo__stretcher"
};
export default styles;